// extracted by mini-css-extract-plugin
export default {"dropdown":"LanguageDropdown--dropdown--631337","dropdownItem":"LanguageDropdown--dropdownItem--8c2836","label":"LanguageDropdown--label--42e4c8"};